import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProvider, TProviderPayloadUpdate, TProviderResponse, adaptProviderFromResponse, adaptProviderToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER } from '../../backend-paths';


export const providerUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_PROVIDER}/:id`,
	(payload: TProviderPayloadUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ADMIN_PROVIDER}/${id}`;
		const dataRequest = adaptProviderToRequest(data);

		return HttpService.put<TProviderResponse>(path, dataRequest).then(result => {
			return adaptProviderFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProvider> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerUpdateSlice = createSlice({
	name: 'providerUpdateSlice',
	initialState,
	reducers: {
		clearProviderUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerUpdateApi.fulfilled.type]: (state, action: PayloadAction<TProvider>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderUpdateSelector = () => useAppSelector(state => state[providerUpdateSlice.name]);

export const { clearProviderUpdate } = providerUpdateSlice.actions;
